<!-- <app-edite-user-details></app-edite-user-details> -->
<!-- start header  -->
<header>
    <app-head (newItemEvent)="addItem($event)" [titleModule]="'Handover'"></app-head>
</header>
<!-- end header  -->

<div class="row m-0">

    <!-- start sidebar  -->
    <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'Handover'"></app-sidebar>
    <!-- end sidebar  -->

    <!-- start content page  -->
    <main class="p-4 col-lg-10 ">
      <div class="d-md-flex justify-content-between align-items-center dashboard" style="margin-top: 8px; margin-bottom: 15px;">
        <p class="fw-bold ms-1" style="color: #6c6a6a;">Handover History</p>
        <div class="d-flex justify-content-lg-between flex-md-row flex-column">

          <div class="d-flex mb-2">
              <!-- start dropdown button  -->
              <app-dropdown class="me-3" [list]="listDropDown" (selected)="selectedfromDropDown($event)"></app-dropdown>
              <!-- end dropdown button  -->
              <!-- start add button (add new owner) in page  -->
              <!-- <app-add-new-button  [id]="'/user/create_new'" class="mt-2"></app-add-new-button> -->
              <!-- end add button (add new owner) in page  -->
          </div>
          <div class="d-flex mb-2 me-3 mb-2">
            <button class="week rounded-start px-3 py-2 bg-w outline-none" (click)="FilterButtons('This Month')" [ngClass]="{'activeButton': monthButton == true}">This Month</button>
            <button class="week px-3 py-2 outline-none rounded-end" (click)="FilterButtons('Last Week')" [ngClass]="{'activeButton': weekButton == true}">Last Week</button>
          </div>
        <button class="px-3 py-2 rounded border text-white text-decoration-none" style="background-color: #1F4068;color: white;"  (click)="navigateToAddHandover()">Add New</button>

        </div>
    </div>


        <p-toast></p-toast>

        <!---------------------------------------------------------------------------------------------------------------------------------------->
      
        <!-----------------------------------------------------------update----------------------------------------------------------------------------->
        <div>
          <div class="p-card p-3" style="border-radius: 16px;" >
            <div class="flex justify-content-between align-items-center mb-4" style="display: flex;">
              <!-- <h2>Subscription Alerts</h2> -->
               <!-- <div class="card-header">Users <span> {{numberTenants}} Users</span></div> -->
               <div class="d-flex mx-2 mt-4">
                <p class="me-2 fs-5 fw-bold ml-8">Handover </p>
                <p class="mb-3 bg-gray rounded-5 blue px-2 d-flex align-items-center">
                    {{numberTenants}} Handover
                </p>
            </div>
              <div class="p-inputgroup w-50" style=" position: relative;">
                <!-- <span class="p-inputgroup-addon">
                  <i class="pi pi-search"></i>
                </span> -->
                <input type="text"  class="search-input" pInputText placeholder="      Search by any key" [(ngModel)]="globalFilter" (input)="dt2.filterGlobal(globalFilter, 'contains')" />
                <i class="pi pi-search search-icon"></i>
                <!-- <button pButton icon="pi pi-filter" class="p-button-outlined"></button> -->
                 <!-- <img src="filterplan.svg" (click)="openFilterDialog()"   style="margin-left: 24px; cursor: pointer;"/> -->
              </div>
            </div>
          <!--[paginator]="true"  [rowsPerPageOptions]="[10, 25, 50]"  [rows]="5"-->
          <p-table
          #dt2
          [value]="Tenants"
          dataKey="id"


          *ngIf="Tenants?.length!==0"
        [paginator]="true" 
        [rows]="10"

       
        [first]="Tenants.length > 0 ? currentPage : 0"
        (onPage)="onPageChange($event)"
           
        [rowsPerPageOptions]="[10, 20, 50]"
         
          
          
          
          [globalFilterFields]="['handoverId', 'workerName', 'date', 'time','type']"
          [tableStyle]="{ 'min-width': '75rem' }"
      >
          <ng-template pTemplate="caption">
              <!-- <div class="flex">
                  <p-iconField iconPosition="left" class="ml-auto">
                      <p-inputIcon>
                          <i class="pi pi-search"></i>
                      </p-inputIcon>
                      <input 
                          pInputText 
                          type="text" 
                          (input)="dt2.filterGlobal(globalFilter, 'contains')"
                          placeholder="Search keyword" />
                  </p-iconField>
              </div> -->
          </ng-template>
          <ng-template pTemplate="header">
              <tr class="headOne">
                  <th style="width:22%">Handover ID</th>
                  <th style="width:22%">Worker Name</th>
                  <th style="width:22%">Date</th>
                  <th style="width:22%">Time</th>
                  <th style="width:12%">Type Of Check</th>
                  <th style="width:6%">Action</th>

              </tr>
              <tr>
                  <th style="width:22%">
                      <p-columnFilter 
                          type="text" 
                          field="handoverId" 
                          placeholder="Search by ID" 
                          ariaLabel="Filter ID" />
                  </th>
                  <th>
                      <p-columnFilter 
                          type="text" 
                          field="workerName" 
                          placeholder="Search by Worker Name" 
                          ariaLabel="Filter Name" />
                  </th>
                  <th>
                    <p-columnFilter 
                    type="text" 
                    field="date" 
                    placeholder="Search by Date" 
                    ariaLabel="Filter Date" />
                  </th>
                 
                  <th>
                    <p-columnFilter 
                    type="text" 
                    field="time" 
                    placeholder="Search by Time" 
                    ariaLabel="Filter Time" />
                  </th>
                  <th>
                    <p-columnFilter 
                    type="text" 
                    field="type" 
                    placeholder="Search by Type" 
                    ariaLabel="Filter Check_Type" />
                  </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-Tenant>
              <tr>
                  <td >
                     {{ Tenant.handoverId }}
                  </td>
                  <td >
                    <!-- <img *ngIf=" Tenant.user_Photo  " routerLink="/users/app-edite-user-details/{{Tenant?.user_ID}}" [src]="Tenant?.user_Photo" style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px;cursor: pointer;"> -->


                            <img *ngIf="!Tenant.user_Photo" routerLink="/users/app-edite-user-details/{{Tenant?.user_ID}}" src="../../../assets/images/Frame 1261154899.svg" style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px;cursor: pointer;">
                      {{ Tenant.workerName }}
                  </td>
                  <td routerLink="/users/app-edite-user-details/{{Tenant?.user_ID}}">
                   {{ Tenant.date}}
                  </td>
                  <!-- <td routerLink="/users/app-edite-user-details/{{Tenant?.user_ID}}">
                      {{ parseDateString(Tenant.reg_Time) | date:'dd-MM-yyyy hh:mm a'}}
                  </td> -->
                   <td routerLink="/users/app-edite-user-details/{{Tenant?.user_ID}}">
                      {{Tenant.time}}
                  </td>
 
                  <td routerLink="/users/app-edite-user-details/{{Tenant?.user_ID}}">
                    <div>
                        <span class="rounded-5 px-3 badge excellent" *ngIf="Tenant?.type=='General Check'">
                          <span>
                            <img src="assets/images/greenDot.svg" alt="">
                          </span>
                          {{Tenant?.type}}
                      </span>
                      <span class="rounded-5 px-3 badge bad" *ngIf="Tenant?.type=='Check-Out'">
                        <span>
                          <img src="assets/images/redDot.svg" alt="">
                        </span>
                        {{Tenant?.type}}
                    </span>
                  
                  <span class="rounded-5 px-3  badge average"  *ngIf="Tenant?.type=='Check-In'">
                    <span>
                      <img src="assets/images/purbleDot.svg" alt="">
                    </span>
                    {{Tenant?.type}}
                </span>
                    </div>
                </td>
                  <!-- <td>
                      <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': customer.verified, 'text-red-500 pi-times-circle': !customer.verified }"></i>
                  </td> -->

                  <td >
                    <div class="flex justify-content-start align-items-center gab-3" style="display: flex;">
                      <!-- <div><img class="mr-2" style="cursor: pointer;" src="alertUser.svg"/></div> -->
                      <!-- <div class=" ">
                        <img
                        *ngIf="TantsRole?.p_Update==true || is_Super==true"
                          class="image-default"
                          src="assets/images/viewPay.svg"
                          alt="Default Alert Icon"
                          [routerLink]="['/users/app-edite-user-details', Tenant.user_ID]"
                        />
                         
                      </div> -->
                      
                      <div>
                        <img class="mr-2" style="cursor: pointer;" src="assets/images/threeDotPay.svg" (click)="op.toggle($event)" />
                      </div>
                      <p-overlayPanel #op>
                        <ul class="menu-list list-unstyled">
                          <li><a    style="cursor: pointer;"  [routerLink]="['/apartments/handover-details', Tenant?.handover_ID]"
 *ngIf="TantsRole?.p_Update==true || is_Super==true"    style="cursor: pointer; Color:#363636; text-decoration: none;" >view Details</a></li>
         

                        </ul>
                      </p-overlayPanel>
                    </div>
                     
 
                  </td>
              </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
              <tr>
                  <td colspan="5">No Handover found.</td>
              </tr>
          </ng-template>
  </p-table>

  <!-- <p-paginator *ngIf="Tenants.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
    [totalRecords]="totalRecords" [first]="first"></p-paginator> -->
          </div>
          
        </div>
        <!---------------------------------------------------------------------------------------------------------------------------------------->


    </main>
    <!-- end content page  -->
</div>

 

 

 
